import { render } from "./ButtonActionRender.vue?vue&type=template&id=9f48c734"
import script from "./ButtonActionRender.vue?vue&type=script&lang=js"
export * from "./ButtonActionRender.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__